import { CONFIG, GameConfig } from "../config";
import { textSwarmLayout, textBunkerLayout } from "../layouts/textLayouts";

/**
 * Mirrors the tokens in section 1 of src/styles/theme.sass. Sass cannot be
 * imported into TypeScript here, so the two are kept in step by hand.
 */
const HERO_COLORS: GameConfig["colors"] = {
  background: "#231C07", // $BackgroundColor
  player: "#e9f8dc", // $mainFontColor
  // The word is seven rows deep and the lower four carry most of the letter
  // shapes, so every band has to hold up against #231C07. $colorEnphasis red
  // does not, and was tried first.
  invaderTop: "#DEFF7F", // $colorTerciary
  invaderMid: "#beccf8", // $mainColorVariation1
  invaderBottom: "#7F96FF", // $colorSecondary
  playerBullet: "#e9f8dc",
  invaderBullet: "#991515",
  bunker: "#e9f8dc",
  text: "#e9f8dc",
  overlay: "rgba(35, 28, 7, 0.6)",
};

/**
 * maxLevels 1 is what makes the attract loop: clearing DEVELOPER trips Win,
 * and autoRestartDelay then rebuilds the word and the eroded name.
 *
 * The bullet settings are the other half. The classic one-shot-at-a-time rule
 * would take nearly three minutes to clear 145 invaders; four concurrent shots
 * on a short cooldown brings a loop down to roughly half a minute.
 */
export const HERO_LANDSCAPE: GameConfig = {
  ...CONFIG,
  canvas: { width: 1600, height: 900 },
  colors: HERO_COLORS,
  hud: false,
  overlay: false,
  autoRestartDelay: 2,
  game: { maxLevels: 1 },
  player: {
    ...CONFIG.player,
    y: 700,
    speed: 220,
    fireCooldown: 0.5, 
    spriteScale: 3,
  },
  bullet: {
    ...CONFIG.bullet,
    playerSpeed: 900,
    invaderSpeed: 260,
    maxInvaderBullets: 4,
    maxPlayerBullets: 8,
  },
  swarm: {
    ...CONFIG.swarm,
    invaderWidth: 22,
    invaderHeight: 16,
    invaderScale: 2,
    // The word nearly fills the canvas, so the fleet shimmies rather than
    // sweeps. Slower speeds keep it readable as type.
    baseSpeed: 12,
    maxSpeed: 80,
    stepDown: 7,
    fireInterval: 0.8,
    minFireInterval: 0.5,
  },
  layout: {
    swarm: textSwarmLayout({
      lines: ["HELLO", "WORLD"],
      cellPitch: 26,
      rowPitch: 26,
      originY: 40,
    }),
    bunkers: textBunkerLayout({
      lines: ["ESTEBAN LASSO"],
      blockSize: 16,
      originY: 560,
    }),
  },
};

/** Phones get the word stacked, at a scale that still reads at 390 CSS px. */
export const HERO_PORTRAIT: GameConfig = {
  ...HERO_LANDSCAPE,
  canvas: { width: 720, height: 1100 },
  player: {
    ...HERO_LANDSCAPE.player,
    y: 1010,
    width: 26,
    height: 16,
    spriteScale: 2,
  },
  swarm: {
    ...HERO_LANDSCAPE.swarm,
    invaderWidth: 11,
    invaderHeight: 8,
    invaderScale: 1.5,
  },
  layout: {
    // 11px sprites in 20px cells left the letters too airy to read at 390 CSS
    // px; 16 lifts the fill from ~55% to ~69% and the word firms up.
    swarm: textSwarmLayout({
      lines: ["HELLO", "WORLD"],
      cellPitch: 18,
      rowPitch: 18,
      originY: 0,
    }),
    bunkers: textBunkerLayout({
      lines: ["ESTEBAN", "LASSO"],
      blockSize: 14,
      originY: 700,
      lineGap: 36,
    }),
  },
};
